(function ($) {

	$('.account__extend-pickup-button').on('click', function(){

		gp_ajax({
			url: ghostpress_params.ajax_url,
			type: "post",
			data: {
				'action': this.getAttribute('data-action'),
				'order_id': this.getAttribute('data-order-id'),
				'order_key': this.getAttribute('data-order-key'),
				'show_loading': true,
			}
		})
	})

})(jQuery)
